export default __webpack_public_path__ + "static/media/Pal_before_1.a4597320.JPG";